import type { BlockExportMapping } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { ImageGalleryBlock1 } from "./ImageGalleryBlock1";

export const galleryBlocks: BlockExportMapping = {
  ImageGalleryBlock1,
};
